import { withModifiers as _withModifiers, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, mergeProps as _mergeProps, Teleport as _Teleport, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-0e31070e")
const _hoisted_1 = { class: "modal" }
const _hoisted_2 = {
  class: "modal__body",
  ref: "modal"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h1", null, "Foto instellen", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", null, "Klik op een van de onderstaande foto's om deze in te stellen.", -1)
const _hoisted_5 = { class: "results" }
const _hoisted_6 = ["disabled", "onClick"]
const _hoisted_7 = { class: "photo" }
const _hoisted_8 = ["href"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "photo-button__loader" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    focusable: "false",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    class: "button__spinner",
    role: "img"
  }, [
    /*#__PURE__*/_createElementVNode("circle", {
      "stroke-width": "2",
      fill: "none",
      cx: "8",
      cy: "8",
      r: "6"
    })
  ])
], -1)
const _hoisted_10 = { style: {"display":"none"} }
const _hoisted_11 = ["id", "href", "width", "height"]
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Teleport, { to: ".modals" }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("button", {
          class: "modal__close",
          onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onCancelClick && _ctx.onCancelClick(...args)), ["prevent"]))
        }, "Annuleren"),
        _hoisted_3,
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.annotations, (annotation) => {
            return (_openBlock(), _createElementBlock("button", {
              class: _normalizeClass(["photo-button", { 'is-loading': _ctx.annotationId === annotation.data.id }]),
              disabled: _ctx.isLoading,
              onClick: _withModifiers(($event: any) => (_ctx.onPictureClick(annotation.data.id)), ["prevent"])
            }, [
              (_openBlock(), _createElementBlock("svg", _hoisted_7, [
                _createElementVNode("use", {
                  href: `#annotation[${annotation.data.id}]`,
                  height: "88",
                  width: "88"
                }, null, 8, _hoisted_8)
              ])),
              _hoisted_9
            ], 10, _hoisted_6))
          }), 256))
        ]),
        (_openBlock(), _createElementBlock("svg", _hoisted_10, [
          _createElementVNode("defs", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.annotations, (annotation) => {
              return (_openBlock(), _createElementBlock("image", _mergeProps({
                id: `annotation[${annotation.data.id}]`,
                href: _ctx.getUrlForFile(annotation.file),
                width: annotation.file.width,
                height: annotation.file.height
              }, _ctx.getAnnotationParameters(annotation.file, annotation.data)), null, 16, _hoisted_11))
            }), 256))
          ])
        ]))
      ], 512)
    ])
  ]))
}